import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import MaintenanceTable from '../../../../components/Tables/Montgomery/GeneralMaintenance';
import ElectricalTable from '../../../../components/Tables/Montgomery/ElectricalMaintenance';
import { MMANavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs, Table } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';

import 'bootstrap/dist/css/bootstrap.min.css';

const SIMaintenancePrevent = () => {
	return (
		<>
			<Header plant="montgomery" />
			<main>
				<wrapper class="section-wrapper">
					<MMANavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/montgomery/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Maintenance</Breadcrumb.Item>
							<Breadcrumb.Item active>Preventive Maintenance</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs defaultActiveKey="General Mechanical Preventive Maintenance Tasks" className="mb-3">
								<Tab eventKey="General Mechanical Preventive Maintenance Tasks" title="General Mechanical Preventive Maintenance Tasks">
									<h2>GENERAL MECHANICAL PREVENTIVE MAINTENANCE</h2>
									<p>The tables are intended as a guideline and should not replace periodic maintenance schedules derived in the plant.</p>
									<MaintenanceTable tablesorter={true} />
								</Tab>

								<Tab eventKey="General Electrical Preventive Maintenance Tasks" title="General Electrical Preventive Maintenance Tasks">
									<h2>GENERAL ELECTRICAL PREVENTIVE MAINTENANCE</h2>
									<p>The tables are intended as a guideline and should not replace periodic maintenance schedules derived in the plant.</p>
									<ElectricalTable tablesorter={true} />
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default SIMaintenancePrevent;
